import React, { useMemo } from 'react';
import clsx from 'clsx';
import { Col, Container, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import Button from '../../Button/Button';
import { useListingRequest } from '../../../Context/ListingRequestContext';
import { matchMultiplePaths } from '../../../Helper/matchMultiplePaths';
import { ListingRequestSource } from '../../../../Interface/ListingRequest';
import { useListingRequestEnabled } from '../../../Hooks/useListingRequestEnabled';
// @ts-ignore
import styles from './ListingRequestCta.module.scss?module';

const COPY: Record<ListingRequestSource, string> = {
  search: 'Missing a specific product?',
  category: 'Missing a specific product in this category?',
  banner: 'New: you can now request product listings you’re missing.',
};

/**
 * Trade show, campaign and outlet flows reuse the shared product list. The listing request is a
 * regular shop feature, so it stays out of those.
 */
const HIDDEN_PATHS = [
  '/virtual-trade-show/*',
  '/vts',
  '/vts-order/*',
  '/newcomer-week/*',
  '/outlet',
  '/outlet/*',
];

type ListingRequestCtaProps = {
  source: ListingRequestSource;
  className?: string;
};

const ListingRequestCta = ({ source, className }: ListingRequestCtaProps) => {
  const { openListingRequest } = useListingRequest();
  const listingRequestEnabled = useListingRequestEnabled();
  const location = useLocation();
  const isHiddenFlow = useMemo(
    () => !!matchMultiplePaths(HIDDEN_PATHS),
    [location.pathname]
  );

  if (!listingRequestEnabled || isHiddenFlow) {
    return null;
  }

  const isBanner = 'banner' === source;

  const bar = (
    <div className={clsx(styles.bar, isBanner ? styles.flush : '')}>
      <span>{COPY[source]}</span>
      <Button onClick={() => openListingRequest(source)}>Request Listing</Button>
    </div>
  );

  // The strip spans the full width, its content stays on the grid of the header and the page.
  if (isBanner) {
    return (
      <Container fluid className={clsx(styles.surface, className)}>
        <Container>
          <Row>
            <Col>{bar}</Col>
          </Row>
        </Container>
      </Container>
    );
  }

  return <div className={clsx(styles.surface, className)}>{bar}</div>;
};

export default ListingRequestCta;
